import _ from 'lodash';

const WordLine = (props) => {
    let line = _.map(props.currentAttempt, (letter, index) => {
        let position = 'previous';
        if (props.index > props.attempt-1)
            position = 'next';
        if (props.index === props.attempt)
            position = 'current';
        return {
            letter: letter,
            correct: false,
            present: false,
            position: position,
            wordLetter: props.word[index]
        };
    });

    let letterCount = {};
    props.word.split('').forEach((x) => {
        return letterCount[x] = (letterCount[x] || 0) + 1;
    });

    // find correct letters
    line = _.map(line, (tile, index) => {
        if (tile.letter === props.word[index]) {
            letterCount[tile.letter]--;
            tile.correct = true;
        }
        return tile;
    });

    // find present letters remaining
    line = _.map(line, (tile, index) => {
        if (props.word.indexOf(tile.letter) >= 0 && tile.letter !== '' && letterCount[tile.letter] > 0) {
            letterCount[tile.letter]--;
            tile.present = true;
        }
        return tile;
    });

    const letters = line.map((tile, index) => {
        return (
            tile.position === 'current'
            ? <div></div>
            : tile.position === 'next'
            ? <div></div>
            : tile.correct
            ? <span>🟩</span>
            : tile.present
            ? <span>🟧</span>
            : <span>⬛</span>
        );
    });

    return (
        <div class="word-line">
            {letters}
        </div>
    )
}

export default WordLine;